import { linkedinSigninStart } from '/providers/auth-api'

const signUpWithGoogle = ({apiSource}) => {
  return new Promise(async (resolve, reject) => {
    const popup = window.open('', 'oauth', 'width=500,height=600')
    if (!popup) return reject(new Error('Popup blocked'))

    let messageReceived = false

    // Detect manual closure only
    const popupCheck = setInterval(() => {
      if (popup.closed && !messageReceived) {
        clearInterval(popupCheck)
        window.removeEventListener('message', handleMessage)
        reject({message:'Login popup closed by user'})
      }
    }, 250)

    const oauth = await linkedinSigninStart({apiSource})

    popup.location.href = oauth.url

    const handleMessage = async (e) => {
      // 🔒 Optional: restrict allowed origins
      const allowed = ['http://local.smartix.uk:4000', 'https://studio.smartix.uk']
      if (!allowed.includes(e.origin)) return

      if (e.data?.token) {
        messageReceived = true
        clearInterval(popupCheck)
        window.removeEventListener('message', handleMessage)
        popup.close()

        resolve(e.data.token)
      }
    }

    window.addEventListener('message', handleMessage)
  })
}

export default signUpWithGoogle